export default {"src":"/_next/static/media/rectangle_prev.e1f6f726.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};